export default __webpack_public_path__ + "static/media/tickbox.90c592f6.svg";